import { render, staticRenderFns } from "./CartGift.vue?vue&type=template&id=f5cc39f2"
import script from "./CartGift.vue?vue&type=script&lang=js"
export * from "./CartGift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports